import { useQuery } from 'react-query';
import format from 'date-fns/format';
import PhotographerCalendarApi from '../../../../photographerBooking/se360/SE360PhotographerBookingApi';
import ICoordinate from '../../../../map/ICoordinate';
import { Forecast } from '../state/weather';

export type LocationData = {
    location: string;
    date: string;
    sunrise: string;
    sunset: string;
    forecasts: Forecast[];
};

export function useLocationQuery(
    bookingDate: Date,
    location: ICoordinate | null,
    enabled: boolean
) {
    const date = format(bookingDate, 'yyyy-MM-dd');

    return useQuery<LocationData>(
        [
            'create-order-location',
            date,
            location ? location.latitude : null,
            location ? location.longitude : null
        ],
        () =>
            PhotographerCalendarApi.getLocationData(
                date,
                undefined,
                location.latitude,
                location.longitude
            ),
        { enabled: enabled && location !== null, cacheTime: 0, refetchOnWindowFocus: false }
    );
}
